// src/models/atributoCotizaModel.js

import pb from '../lib/pocketbase';

// Obtener una lista de atributos de cotización con paginación
export async function getAtributoCotizas(page, perPage) {
  return await pb.collection('atributo_cotiza').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false,
    expand: 'atributo,cotiza_cab'
  });
}

// Crear un nuevo atributo de cotización
export async function createAtributoCotiza(atributoCotiza) {
  return await pb.collection('atributo_cotiza').create(atributoCotiza);
}

// Actualizar un atributo de cotización existente
export async function updateAtributoCotiza(id, atributoCotiza) {
  return await pb.collection('atributo_cotiza').update(id, atributoCotiza);
}

// Eliminar un atributo de cotización por su ID
export async function deleteAtributoCotiza(id) {
  return await pb.collection('atributo_cotiza').delete(id);
}

// Obtener atributos de cotización por cotiza_cab
export async function getAtributoCotizasByCotizaCab(cotizaCabId, page = 1, perPage = 50) {
  return await pb.collection('atributo_cotiza').getList(page, perPage, {
    filter: `cotiza_cab = "${cotizaCabId}"`,
    sort: '-created',
    $autoCancel: false,
    expand: 'atributo'
  });
}

// Obtener atributo de cotización por ID con expansiones
export async function getAtributoCotizaById(id) {
  return await pb.collection('atributo_cotiza').getOne(id, {
    expand: 'atributo,cotiza_cab'
  });
}
